import gql from 'graphql-tag';

export const PORTAL_ESTABLISHMENTS_QUERY = gql`
  query ($operatorId: String!) {
    operator(id: $operatorId) {
      establishments {
        channel
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Layout/Sidebar/graphql.js